import {getFileSizeMB, toBase64} from './utils';

type CompressFileOptions = {convertSize?: number};

const IDENTITY_VERIFICATION_PHOTOS_MAX_SIZE_MB = 6;
const IDENTITY_VERIFICATION_PHOTOS_QUALITY = 0.8;

async function compressFile(file: Blob, {convertSize}: CompressFileOptions) {
  const {default: Compressor} = await import('compressorjs');

  return new Promise<Blob>((resolve, reject) => {
    new Compressor(file, {
      convertSize: convertSize ? convertSize * 1000000 : undefined,
      quality: 1,
      success: result => resolve(result),
      error: reject,
    });
  });
}

async function compressImage(image: File) {
  const {default: Compressor} = await import('compressorjs');
  const parsedImage = new File([image], image.name, {type: image.type});

  return new Promise<string>((resolve, reject) => {
    new Compressor(parsedImage, {
      convertSize: IDENTITY_VERIFICATION_PHOTOS_MAX_SIZE_MB * 1000000,
      quality: IDENTITY_VERIFICATION_PHOTOS_QUALITY,
      success: compressedResult => {
        toBase64(compressedResult).then(result => {
          // eslint-disable-next-line no-console
          console.log(
            'Before: ',
            getFileSizeMB(image)?.toFixed(2),
            'MB',
            'After: ',
            getFileSizeMB(compressedResult)?.toFixed(2),
            'MB',
          );
          resolve(result);
        }, reject);
      },
      error: error => {
        if (error.message.includes('Failed to load the image')) {
          reject(
            new Error(
              'Unable to process the selected image. Please try a different image.',
            ),
          );
          return;
        }

        reject(error);
      },
    });
  });
}

export {compressFile, compressImage};
